@if (show) {
  <div class="modal-overlay" (click)="onClose()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>
          <fa-icon [icon]="faChartLine"></fa-icon>
          {{ 'INTERACTIONS.CREATE_TITLE' | translate }}
        </h3>
        <button class="close-btn" (click)="onClose()" type="button">
          <fa-icon [icon]="faTimes"></fa-icon>
        </button>
      </div>
      <div class="modal-body">
        <form (ngSubmit)="onCreate()" autocomplete="off">
          <div class="form-group">
            <label for="interactionName">{{ 'INTERACTIONS.FORM.NAME' | translate }}</label>
            <input
              id="interactionName"
              type="text"
              [(ngModel)]="name"
              name="name"
              [disabled]="loading"
              required
              autocomplete="off"
              class="form-control"
              maxlength="100"
              />
          </div>
          <div class="form-group">
            <label for="simulationType">{{ 'SIMULATIONS.TYPE.LABEL' | translate }}</label>
            <div class="select-wrapper">
              <select
                id="simulationType"
                [(ngModel)]="simulationType"
                name="simulationType"
                class="form-control"
                [disabled]="loading">
                @for (type of simulationTypes; track type.value) {
                  <option [value]="type.value">{{ type.labelKey | translate }}</option>
                }
              </select>
            </div>
          </div>
          @if (error) {
            <div class="error-message">
              {{ error | translate }}
            </div>
          }
          <div class="form-actions">
            <button
              type="button"
              class="cancel-button"
              (click)="onClose()"
              [disabled]="loading"
              >
              {{ 'BUTTON.CANCEL' | translate }}
            </button>
            <button
              type="submit"
              class="save-button"
              [disabled]="loading || !name.trim()"
              >
              <fa-icon [icon]="faCheck"></fa-icon>
              {{ 'BUTTON.CREATE' | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
}